import { FormikValues } from 'formik';
import { ExtendedRuleDefinition, FactDefinition, ConditionBehaviourTypeEnum } from '../gen/api';
import { EffectiveFactBehaviourEnum } from '../components/ConfigurationForm/ConfigurationFormSchema';

const useFieldHelpers = () => {
    const generateFieldNameFromCodes = (ruleCode: string, factCode: string, factNamePrefix: string = '') => {
        const prefix = factNamePrefix === '' ? '' : factNamePrefix.concat('-');

        return prefix.concat('RULE-').concat(ruleCode).concat('-FACT-').concat(factCode).replace(/[.]/g, '@DOT@');
    };

    const isFieldValueIncluded = (fieldName: string, values: FormikValues, possibleValues: string[]) => {
        return possibleValues.some((i) => i == values[fieldName]);
    };

    const getEffectiveFactBehaviour = (
        factDefinition: FactDefinition,
        values: FormikValues,
    ): EffectiveFactBehaviourEnum => {
        if (factDefinition.behaviour?.alwaysMandatory) {
            return EffectiveFactBehaviourEnum.MANDATORY;
        }

        if (factDefinition.behaviour?.conditions) {
            const relevantConditionsSorted = factDefinition.behaviour.conditions
                .filter(
                    (condition) =>
                        (condition.ruleCode &&
                            condition.factCode &&
                            isFieldValueIncluded(
                                generateFieldNameFromCodes(condition.ruleCode, condition.factCode),
                                values,
                                condition.values || [],
                            )) ||
                        (condition.propertyName &&
                            isFieldValueIncluded(condition.propertyName, values, condition.values || [])),
                )
                .sort((a, b) => (b.priority || 0) - (a.priority || 0));

            if (relevantConditionsSorted.length == 0) {
                return EffectiveFactBehaviourEnum.OPTIONAL;
            } else if (relevantConditionsSorted[0].behaviourType == ConditionBehaviourTypeEnum.MANDATORY) {
                return EffectiveFactBehaviourEnum.MANDATORY;
            } else {
                return EffectiveFactBehaviourEnum.IGNORED;
            }
        }

        return EffectiveFactBehaviourEnum.OPTIONAL;
    };

    const generateFieldName = (
        ruleDefinition: ExtendedRuleDefinition,
        factDefinition: FactDefinition,
        factNamePrefix: string = '',
    ) => generateFieldNameFromCodes(ruleDefinition.ruleCode, factDefinition.factCode, factNamePrefix);

    const getFieldValue = (fieldName: string, values: FormikValues) => values[fieldName];

    return {
        generateFieldName,
        generateFieldNameFromCodes,
        getFieldValue,
        getEffectiveFactBehaviour,
    };
};

export default useFieldHelpers;
